let locale = null
export function getLocale(defaultLocale = "default") {
	return locale ?? defaultLocale
}
export function setLocale(l) {
	locale = l
}
